import { isReactElement } from "@/app/(site)/_utils/misc/react"
import { hasVisibleText } from "@/src/utils/a11y/hasVisibleText"
import React from "react"

const GCFontMap = {
    14: "font-tradeLightNew text-14",
    16: "font-tradeLightNew text-16",
    18: "font-tradeLightNew text-18",
    20: "font-tradeLightNew text-20",
    24: "font-tradeLightNew text-24"
}
// Trade Gothic LT Pro
const GCTagMap = {
    p: "p",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6"
}
export interface StoryTextProps extends React.HTMLAttributes<HTMLParagraphElement> {
    size?: "size1" | "size2" | "size3" | "size4" | "size5"
    GCFontSize?: keyof typeof GCFontMap
    GCTag?: keyof typeof GCTagMap
    children: React.ReactNode
    asChild?: boolean
}

const fontSizeMap = {
    size1: "md:text-48 text-32",
    size2: "md:text-32 text-24",
    size3: "md:text-24 text-16",
    size4: "md:text-16 text-14",
    size5: "md:text-14 text-14"
}

const lineHeightMap = {
    size1: "md:leading-100 leading-100",
    size2: "md:leading-120 leading-120",
    size3: "md:leading-130 leading-130",
    size4: "md:leading-130 leading-130",
    size5: "md:leading-130 leading-130"
}

const StoryText: React.FC<StoryTextProps> = ({
    size = "size1",
    GCFontSize,
    GCTag = "p",
    children,
    className,
    asChild,
    ...props
}) => {
    const fontSize = fontSizeMap[size]
    const lineHeight = lineHeightMap[size]
    const combinedFontLineHeightClassNames = `${fontSize} ${lineHeight} font-tradeLightNew`

    const combinedClassNames = GCFontSize
        ? `${GCFontMap[GCFontSize]}`
        : combinedFontLineHeightClassNames

    if (
        (GCTag === "h2" ||
            GCTag === "h3" ||
            GCTag === "h4" ||
            GCTag === "h5" ||
            GCTag === "h6") &&
        !hasVisibleText(children)
    ) {
        return null
    }

    if (asChild && isReactElement(children)) {
        const child = children as React.ReactElement<{ className?: string }>
        return React.cloneElement(child, {
            className: `${child.props.className || ""} ${combinedClassNames}`,
            ...props
        })
    }

    return React.createElement(
        GCTagMap[GCTag],
        { className: `${combinedClassNames} ${className || ""}`, ...props },
        children
    )
}

export default StoryText
